const isUndefined = (value) => {
    if (value === undefined) { return true; }
    else { return false; }
};

export default isUndefined;
